import Text from '@cartwhl/ui/base/Text';

import ContactButton from './ContactButton';
import { planConfigs, planRows } from './tableSectionData';

export default function MobilePlanCards() {
  const whoItsFor = planRows.find((r) => r.label === "Who it's for")!;
  const apiAccess = planRows.find((r) => r.label === 'API Access')!;

  return (
    <div>
      <Text as="div" variant="web/display/2xl" className="mb-8">
        Plans
      </Text>
      <div className="flex flex-col gap-6">
        {planConfigs.map((plan) => {
          const features = whoItsFor[plan.key];
          const access = apiAccess[plan.key];

          return (
            <div
              key={plan.name}
              className={`flex flex-col rounded-2xl border p-6 ${plan.cardClassName}`}
            >
              <Text
                as="h3"
                variant="web/display/lg"
                lg:variant="web/display/xl"
                className="flex items-center gap-3"
              >
                {plan.dotClassName && (
                  <span
                    className={`h-6 w-6 rounded-full ${plan.dotClassName}`}
                  />
                )}
                {plan.name}
              </Text>

              <div className="mt-12">
                <Text
                  as="div"
                  variant="web/body/medium/md"
                  className="text-secondary mb-3"
                >
                  For
                </Text>
                {Array.isArray(features) && (
                  <div className="flex flex-col gap-4">
                    {features.map((item) => (
                      <Text key={item} as="div" variant="web/body/medium/md">
                        {item}
                      </Text>
                    ))}
                  </div>
                )}
              </div>

              <div className="mt-8">
                {access === 'contact' ? (
                  <ContactButton label="Contact us for API access" />
                ) : (
                  <>
                    <Text
                      as="div"
                      variant="web/body/medium/md"
                      className="text-tertiary mb-2"
                    >
                      API Access
                    </Text>
                    <Text
                      as="div"
                      variant="web/body/medium/lg"
                      lg:variant="web/display/xl"
                    >
                      {access}
                    </Text>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
